import http from 'hub-http/clients/apiClient';
const BASE_URL = 'forms/v2/permissions';
const setFormsPermissions = (formIds = [], {
  selectedTeamIds: teamIds = [],
  selectedUserIds: userIds = []
}) => {
  const formattedRequest = formIds.map(formGuid => ({
    formGuid,
    teamIds,
    userIds
  }));
  return http.post(`${BASE_URL}/batch`, {
    data: formattedRequest
  });
};
export default setFormsPermissions;